import { atom, selector } from 'recoil';
import { verificarToken } from './storage';
import { Catalogs } from '@/typings/catalogs';
import UtileriasRepository from '@/services/apirest/UtileriasRepository';

interface Catalogos {
  data: Catalogs;
  error: any;
}

async function fetchCatalogos() {
  let catalogos;
  await UtileriasRepository.getCatalogos()
    .then(response => {
      catalogos = {
        data: response.data,
        error: false,
      } as Catalogos;
    })
    .catch(error => {
      catalogos = {
        error: error.message,
      } as Catalogos;
    });
  return catalogos;
}

const catalogosEffect =
  () =>
  ({ trigger, setSelf }) => {
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (trigger === 'get' && token && verificarToken(token)) {
      setSelf(fetchCatalogos());
    }
  };

const catalogosState = atom({
  key: 'catalogosState',
  default: {} as Catalogos,
  effects: [catalogosEffect()],
});

export const catalogosInfo = selector({
  key: 'catalogosInfo',
  get: ({ get }) => ({
    catalogos: get(catalogosState),
    data: get(catalogosState).data,
    gradosDeEstudio: get(catalogosState).data.gradosDeEstudio,
    instituciones: get(catalogosState).data.instituciones,
    modalidasDeEstancias: get(catalogosState).data.modalidasDeEstancias,
    segurosDeSalud: get(catalogosState).data.segurosDeSalud,
    tiposDeEstancia: get(catalogosState).data.tiposDeEstancia,
    error: get(catalogosState).error,
  }),
});
